import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import { PainPoints, TrustBanner, BottomCTA, FAQ, Footer } from "@/components/landing/Sections";
import ThankYouOverlay from "@/components/landing/ThankYou";
import CookieBanner from "@/components/landing/CookieBanner";

export default function Landing() {
  const [showThanks, setShowThanks] = useState(false);

  return (
    <div className="bg-white text-[#1A1A1A] overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <PainPoints />
        <HowItWorks />
        <TrustBanner />
        <BottomCTA onSuccess={() => setShowThanks(true)} />
        <FAQ />
      </main>
      <Footer />
      <CookieBanner />
      <AnimatePresence>
        {showThanks && <ThankYouOverlay onReset={() => setShowThanks(false)} />}
      </AnimatePresence>
    </div>
  );
}
